angular
  .module('picmonicng')

  .factory('PicmonicQueue', [
    '$state',
    '$filter',
    'BrowseService',
    'Playlists',
    'Tracks',
    'TokenService',
    'UserService',
    '$modal',
    'Picmonics',
    function ($state, $filter, BrowseService, Playlists, Tracks, TokenService, UserService, $modal, Picmonics) {
      return {
        picmonics: [],
        startedWith: null,
        track_id: null,
        playlist_id: null,
        studyplan_id: null,
        setAndPlay: function (picmonics, startWith, autoplay, track_id, playlist_id, newTab, studyplan_id) {
          var self = this,
            slug,
            card_id;

          self.setQueue(picmonics);
          self.track_id = track_id;
          self.playlist_id = playlist_id;
          self.studyplan_id = studyplan_id;

          if (startWith) {
            self.startedWith = startWith;

            slug = self.picmonics[$filter('arrayPos')(self.picmonics, startWith, 'card_id')].slug;
            card_id = startWith;
          } else {
            self.startedWith = null;

            slug = self.picmonics[0].slug ? self.picmonics[0].slug : self.picmonics[0].card_slug;
            card_id = self.picmonics[0].card_id;
          }

          if (newTab) {
            window.open('/learn/' + slug, '_blank');
            return;
          }

          if (playlist_id && playlist_id != 'bookmarked' && playlist_id != 'mypicmonics') {
            Playlists.update({
              last_viewed_card_id: startWith ? startWith : self.picmonics[0].card_id,
              playlist_id: playlist_id,
            });
          } else if (track_id) {
            Tracks.updatev3({
              last_viewed_card_id: startWith ? startWith : self.picmonics[0].card_id,
              track_id: track_id,
            });
          }

          if (BrowseService.browseOpen) {
            BrowseService.close();
          }
          const studyPlanParams = studyplan_id ? !!studyplan_id : null;

          $state.go('app.learn', { slug: slug, nomodal: autoplay, studyPlan: studyPlanParams });
        },
        setAndQuiz: function (picmonics, startWith) {
          var self = this,
            slug;
          self.setQueue(picmonics);

          if (startWith) {
            self.startedWith = startWith;
            slug = self.picmonics[$filter('arrayPos')(self.picmonics, startWith, 'card_id')].slug;
          } else {
            self.startedWith = null;
            slug = self.picmonics[0].slug ? self.picmonics[0].slug : self.picmonics[0].card_slug;
          }

          if (BrowseService.browseOpen) {
            BrowseService.close();
          }

          self.goToQuiz(slug);
        },
        openQuizLimitModal: function (slug, type, name) {
          $modal.open({
            templateUrl: '/templates/modals/quiz-limit.html',
            windowClass: 'prequiz-modal',
            backdrop: 'static',
            keyboard: false,
            controller: [
              '$scope',
              '$modalInstance',
              'PlaylistService',
              'TokenService',
              'UserService',
              'MarketOptionsConfig',
              '$state',
              '$modal',
              '$timeout',
              'Picmonics',
              'BrowseService',
              'User',
              '$rootScope',
              function (
                $scope,
                $modalInstance,
                PlaylistService,
                TokenService,
                UserService,
                MarketOptionsConfig,
                $state,
                $modal,
                $timeout,
                Picmonics,
                BrowseService,
                User,
                $rootScope
              ) {
                $scope.slug = slug;
                $scope.name = name;
                $scope.UserService = UserService;
                $scope.TokenService = TokenService;
                $scope.BrowseService = BrowseService;
                $scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
                $scope.stats = User.getv3({ resource: 'spacedrepstats' });
                $scope.closable = $state.current.name !== 'app.quiz';
                $scope.splitValueB = UserService.freemiumSplitTest() === 'b';
                $scope.closeStyle = $scope.splitValueB ? { position: 'relative', top: '6px', right: '32px' } : {};

                $scope.openBrowse = function () {
                  BrowseService.toggleOpen();
                  $modalInstance.close();
                };

                TokenService.values.$promise.then(function () {
                  $scope.stats.$promise.then(function () {
                    $scope.canPlay = TokenService.values.tokens && type == 'picmonic';
                    $scope.canQuiz = false;
                    $scope.canSpacedRep =
                      (!UserService.user.is_trial || TokenService.values.spacedrep_rounds) &&
                      ($scope.stats.next > 0 || $scope.stats.current_left > 0) &&
                      !$rootScope.embed;
                    $scope.inMarket = true;

                    if (type == 'picmonic') {
                      Picmonics.get({ slug: slug, setViewed: false }, function (picmonic) {
                        $scope.targetPicmonic = picmonic;
                        $scope.inMarket =
                          !!$filter('filter')(picmonic.primary_tracks, { market_id: UserService.user.lead }, true)
                            .length ||
                          $filter('filter')(picmonic.primary_tracks, {
                            market_is_pseudo: 1,
                          }).length;
                      });
                    }
                  });
                });
              },
            ],
          });
        },
        goToQuiz: function (slug, type, facts, name) {
          var self = this;
          type = type || 'picmonic';
          if (UserService.user.is_trial && type != 'spacedrep' && TokenService.values.quiz_questions < 1) {
            if (type === 'picmonic') {
              Picmonics.get({ slug: slug, setViewed: 0 }).$promise.then(function (c) {
                c.is_free | c.is_owned
                  ? $state.go(
                      'app.quiz',
                      { quiz_type: type, resource_id: slug },
                      { reload: $state.current.name === 'app.quiz' }
                    )
                  : self.openQuizLimitModal(slug, type, name);
              });
            } else {
              self.openQuizLimitModal(slug, type, name);
            }
          } else {
            if (type != 'picmonic') {
              var modal = $modal.open({
                templateUrl: '/templates/modals/quiz-round-size.html',
                backdropClass: 'above-nav',
                size: 'sm',
                controller: [
                  '$scope',
                  'UserService',
                  'User',
                  'ResourceUpgradeModalService',
                  function ($scope, UserService, User, ResourceUpgradeModalService) {
                    $scope.facts = facts;
                    $scope.type = type;
                    $scope.name = name;
                    $scope.spaced_rep_queue_max = UserService.user.settings.spaced_rep_queue_max;
                    $scope.spaced_rep_round_max = UserService.user.settings.spaced_rep_round_max;
                    $scope.is_trial = UserService.user.is_trial;
                    $scope.dailyQuiz = false;
                    var params = { resource: 'spacedrep', facts_only: 1 };
                    params[type + '_id'] = (slug + '').substr(('' + slug).lastIndexOf('-') + 1);
                    User.getv3(params).$promise.then(function (response) {
                      $scope.dailyQuizFacts = response.facts.length;
                    });

                    $scope.upgrade = ResourceUpgradeModalService.show;

                    $scope.saveSettings = function () {
                      if ($scope.dailyQuiz) {
                        var rparams = {
                          quiz_type: 'spacedrep',
                          resource_id: 'today',
                        };
                        rparams[type + '_id'] = (slug + '').substr(('' + slug).lastIndexOf('-') + 1);
                      } else {
                        var rparams = { quiz_type: type, resource_id: slug };
                      }

                      if ($scope.remember && !UserService.user.settings.hide_quiz_round_modal) {
                        UserService.user.settings.hide_quiz_round_modal = 1;
                        UserService.user.$update();
                      }

                      if ($scope.spaced_rep_round_max == UserService.user.settings.spaced_rep_round_max) {
                        $scope.$close(rparams);
                        return;
                      }

                      if ($scope.spacedrepsettings.$invalid || $scope.loading) {
                        return;
                      }
                      $scope.loading = true;

                      UserService.user.settings.spaced_rep_round_max = $scope.spaced_rep_round_max;

                      UserService.user.$update().then(function () {
                        if (type == 'spacedrep') {
                          $scope.stats = User.getv3({
                            resource: 'spacedrepstats',
                          }).$promise.then(function () {
                            $scope.$close(rparams);
                          });
                        } else {
                          $scope.$close(rparams);
                        }
                      });
                    };
                  },
                ],
              });

              modal.result.then(function (result) {
                $state.go('app.quiz', result, {
                  reload: $state.current.name === 'app.quiz',
                });
              });
            } else {
              $state.go(
                'app.quiz',
                { quiz_type: type, resource_id: slug },
                { reload: $state.current.name === 'app.quiz' }
              );
            }
          }
        },
        setQueue: function (picmonics) {
          var self = this;
          if (picmonics.length) {
            self.picmonics = angular.copy(picmonics);
          } else if (picmonics) {
            self.picmonics = [];
            self.picmonics.push(angular.copy(picmonics));
          }
        },
        setCurrent: function (slug) {
          var self = this;

          var current = self.picmonics[$filter('arrayPos')(self.picmonics, true, 'current')];
          if (current) {
            current.current = false;
          }

          var newCurrent = self.picmonics[$filter('arrayPos')(self.picmonics, slug, 'slug')];

          if (newCurrent) {
            newCurrent.current = true;
          }
        },
        current: function () {
          var self = this;
          return self.picmonics[$filter('arrayPos')(self.picmonics, true, 'current')];
        },
        next: function (returnNext) {
          var self = this;

          var currentPos = $filter('arrayPos')(self.picmonics, true, 'current');

          if (currentPos !== null && self.picmonics[currentPos + 1]) {
            if (returnNext) {
              return self.picmonics[currentPos + 1];
            } else {
              if (self.playlist_id) {
                Playlists.update({
                  last_viewed_card_id: self.picmonics[currentPos + 1].card_id,
                  playlist_id: self.playlist_id,
                });
              } else if (self.track_id) {
                Tracks.updatev3({
                  last_viewed_card_id: self.picmonics[currentPos + 1].card_id,
                  track_id: self.track_id,
                });
              }

              $state.go('app.learn', {
                slug: self.picmonics[currentPos + 1].slug,
              });
            }
          } else {
            if (!returnNext) {
              BrowseService.toggleOpen();
            }
          }
        },
        previous: function (returnPrevious) {
          var self = this;

          var currentPos = $filter('arrayPos')(self.picmonics, true, 'current');

          if (currentPos !== null && self.picmonics[currentPos - 1]) {
            if (returnPrevious) {
              return self.picmonics[currentPos - 1];
            } else {
              if (self.playlist_id) {
                Playlists.update({
                  last_viewed_card_id: self.picmonics[currentPos - 1].card_id,
                  playlist_id: self.playlist_id,
                });
              } else if (self.track_id) {
                Tracks.updatev3({
                  last_viewed_card_id: self.picmonics[currentPos - 1].card_id,
                  track_id: self.track_id,
                });
              }
              $state.go('app.learn', {
                slug: self.picmonics[currentPos - 1].slug,
              });
            }
          }
        },
      };
    },
  ]);
